import { io } from "socket.io-client";
import { BASE_URL } from "./Constants/common";
import { getAccessToken } from "./Helper/user.helper";

export const socket = io(BASE_URL, {
  autoConnect: false,
  transports: ["websocket"],
  withCredentials: true,
  auth: {
    token: getAccessToken(),
  },
  reconnectionAttempts: 5,
});

// The module is evaluated before the user logs in, so the handshake token has
// to be refreshed from storage every time we (re)connect.
export const syncSocketAuthToken = () => {
  socket.auth = { token: getAccessToken() };
};

export const connectSocket = () => {
  syncSocketAuthToken();
  if (!socket.connected) {
    socket.connect();
  }
};
